import { useEffect } from "react";
import { Link, useLocation } from "@reach/router";
import { Flex } from "@chakra-ui/core";
import { Button } from "components/Button";
import { Icon } from "assets/Icon";
import { cn } from "utils/helpers";
import { reverseSlug } from "helpers/linkHelper";
import { Box } from "@chakra-ui/react";
import { selectCurrentCompanyId } from "newui/features/Auth/authSelectors";
import { useAppSelector } from "newui/store/hooks";
import { useCurrentUser } from "hooks/auth";

const hideBreadcrumbLists = ["edit-rfq", "create-rfq"];

export const Breadcrumbs = ({
	className,
	ignoreCompany,
	templateRoutes = {},
	parentPath = {},
}) => {
	const maxCharachters = 80;
	const location = useLocation();
	const companyId = useAppSelector(selectCurrentCompanyId);
	const { isGuest } = useCurrentUser();
	let pathName = location.pathname;
	let rootUrl = `/account/${companyId}`;
	if (ignoreCompany) {
		rootUrl = `/account/`;
	}

	pathName = pathName.replace(rootUrl, "");
	const crumbs = pathName
		.split("/")
		.filter((path) => path !== "" && !Number(parseInt(path)));

	// Handle template routes
	const currentPath = crumbs[crumbs.length - 1];
	if (templateRoutes[currentPath] && parentPath[currentPath]) {
		const parentRoute = parentPath[currentPath];
		if (!crumbs.includes(parentRoute)) {
			crumbs.splice(crumbs.length - 1, 0, parentRoute);
		}
	}

	const rfqDetailPath = /rfx\/[^/]+\/[^/]+$/.test(location.pathname);
	const scrollElement = window.document.getElementById("element-scroll");

	const isHidden = hideBreadcrumbLists.some((path) =>
		location.pathname.includes(path)
	);

	const pathFunc = (i) => {
		let lastChar = rootUrl.charAt(rootUrl.length - 1);
		if (lastChar === "/") {
			rootUrl = rootUrl.slice(0, -1);
		}
		let url = `${rootUrl}`;
		for (let a = 0; a <= i; a++) {
			if (crumbs[a] === "company-profile" && i === 0) {
				url = `${url}/${crumbs[a]}/company-information`;
			} else {
				url = url + "/" + crumbs[a];
			}
		}
		return url;
	};

	const pathNameFunc = (name) => {
		// Handle template route names
		if (templateRoutes[name]) {
			return templateRoutes[name];
		}

		let slug = reverseSlug(name);

		if (slug.includes(["create-rfx", "edit-rfx"])) {
			return slug.split(" ")[0] + " RFx";
		}

		if (slug === "rfx project editor") {
			return "Edit Project";
		}

		if (slug === "request for quote") {
			return "RFx";
		}
		if (rfqDetailPath) {
			return slug.replace(/&/g, " | ");
		} else if (slug.length > maxCharachters) {
			return slug.substring(0, maxCharachters) + "...";
		} else {
			return slug;
		}
	};

	useEffect(() => {
		if (scrollElement) {
			scrollElement.scrollTop = 0;
		}
	}, [location.pathname, scrollElement]);

	const DisplayPath = ({ c, i }) => {
		const showLink = crumbs.length - 1 !== i;

		return (
			<>
				<div
					className="item-center relative h-[16px] w-[16px] content-center text-fg-senary-300"
					style={{ textAlign: "-webkit-center" }}
				>
					<Icon
						icon="chevron-right"
						className="relative ml-[1px] h-[16px] w-[16px] content-center items-center"
					/>
				</div>
				{showLink ? (
					<div className="px-2">
						<Button
							btntype="link"
							as={Link}
							to={pathFunc(i)}
							size="sm"
							className="!px-0 !py-0 font-roboto capitalize"
							active={crumbs.length - 1 === i}
						>
							<span
								style={{
									color: crumbs.length - 1 === i ? "#0031DD" : "inherit",
									fontSize: "14px",
								}}
								className="!ml-0 inline-flex p-2 font-roboto font-semibold capitalize"
							>
								{pathNameFunc(c)}
							</span>
						</Button>
					</div>
				) : (
					<div className="px-2">
						<span
							style={{ color: "inherit", fontSize: "14px" }}
							className="!ml-0 inline-flex px-1 py-2 font-roboto font-semibold capitalize"
						>
							{pathNameFunc(c)}
						</span>
					</div>
				)}
			</>
		);
	};

	const directHome = () => {
		if (isGuest === "guest") {
			return "rfx";
		} else {
			return "company-profile/company-information";
		}
	};

	return (
		<Box
			className={cn(
				"items-center p-0",
				isHidden && "hidden",

				className
			)}
		>
			<Flex
				align={"center"}
				className={`gap-3 ${location?.pathname?.includes("search") ? "px-12 py-2" : "px-0"}`}
			>
				<Link
					to={directHome()}
					className="text-breadcrumb-icon-fg"
				>
					<Icon
						icon="house"
						size="iconSm"
						style={{ width: "20px", height: "20px" }}
					/>
				</Link>
				<Flex className="h-[32px] items-center justify-start">
					{crumbs.map((c, i) => {
						return (
							<DisplayPath
								c={c}
								i={i}
							></DisplayPath>
						);
					})}
				</Flex>
			</Flex>
		</Box>
	);
};
